<template>
  <div class="cpsl-legend" :style="{ backgroundImage: `url('${BG}')` }">
    <CrownIcon /> Легенда
  </div>
</template>

<script setup>
  import CrownIcon from '@shared/UI/SVG/CrownIcon.vue';
  //----------------------
  const BG = require('@/Shared/images/backgrounds/legend_bg.png');
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>